module.exports = __webpack_public_path__ + "static/media/samsung-logo-light.c79a55b7.png";